import { Link } from "react-router-dom";
import { newsSortLatest } from "@/lib/content";
import { newsList } from "@/mocks/news";

export default function NewsFlashPanel() {
  const items = newsSortLatest(newsList).slice(0, 5);

  return (
    <aside className="h-full flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between pb-3 border-b border-background-200">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <span className="w-1.5 h-4 rounded-sm bg-accent-500" />
          影视快讯
        </h2>
        <span className="text-[11px] text-foreground-400 font-label">LIVE</span>
      </div>

      <ul className="flex-1 divide-y divide-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <Link to={`/detail/news/${item.id}`} className="group block py-3 cursor-pointer">
              <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                <span className="text-accent-600 font-semibold">{item.category}</span>
                <span className="w-1 h-1 rounded-full bg-background-300" />
                <span className="font-label">{item.publishDate.slice(5).replace("-", "/")}</span>
              </div>
              <p className="mt-1.5 text-[13px] leading-6 font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">
                {item.title}
              </p>
            </Link>
          </li>
        ))}
      </ul>

      <Link
        to="/category/news"
        className="mt-3 inline-flex items-center justify-center gap-1.5 h-9 rounded-md border border-background-300 text-[13px] font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
      >
        查看全部资讯
        <i className="ri-arrow-right-line" />
      </Link>
    </aside>
  );
}